var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33549 0.346229C3.09131 0.188159 2.81768 0.081119 2.53106 0.031548C2.24443 -0.018023 1.95074 -0.00910028 1.66766 0.0577794L11.5905 9.98068L14.8066 6.76464L3.33549 0.346229ZM0.436047 0.864389C0.159285 1.23233 0 1.6841 0 2.162V19.8375C0 20.3155 0.159328 20.7672 0.436047 21.1352L10.5714 10.9998L0.436047 0.864389ZM19.0038 9.11314L16.1135 7.49593L12.6096 10.9998L16.1136 14.5038L19.0043 12.8864C19.6968 12.4984 20.1102 11.7932 20.1102 10.9998C20.1102 10.2063 19.6968 9.50115 19.0038 9.11314ZM11.5905 12.0189L1.66822 21.9411C1.8309 21.9794 1.99646 22 2.16202 22C2.57842 22 2.98593 21.8795 3.33549 21.6533L14.8066 15.2349L11.5905 12.0189Z",
    fill: "#1885CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP9);
export default __webpack_public_path__ + "static/media/p9.b311b47cd24e9dda4d21843297975111.svg";
export { ForwardRef as ReactComponent };